export default "__VITE_ASSET__EXt4v8Fc__"